import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        isTrial: '=',
        selectedLanguage: '='
    },
    template: `
        <p class="note"><a ng-click="vm.toggleHint()">{{ vm.label }}</a></p>
        <p ng-if="vm.showHint">{{ vm.getHintText() }}</p>
    `
})
export default class {
    constructor ($translate, TokenService) {
        this.$translate = $translate;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    $onInit () {
        this.showHint = false;
        this.label = this.$translate.instant('form.Show hint');
    }

    toggleHint () {
        this.showHint = !this.showHint;
        this.label = this.showHint ? this.$translate.instant('form.Hide hint') : this.$translate.instant('form.Show hint');
    }

    getHintText () {
        if (this.isTrial) {
            return (this.question.questionI18ns[this.selectedLanguage] && this.question.questionI18ns[this.selectedLanguage].hint) ?
                this.question.questionI18ns[this.selectedLanguage].hint :
                this.question.questionI18ns[this.defaultLanguage].hint
                ;
        }
        return this.question.activeI18n.hint;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/question/hint/index.js